<template>
  <div>
    <div class="logo">
      <b-row class="text-center text-white">
        <!-- Show connecting state when no valid stats yet or explicitly connecting -->
        <template v-if="!hasValidStats || phoneConnecting">
          <b-col>
            <h4 class="mt-0 mb-2">Connecting...</h4><i class="fas fa-spinner fa-2x fa-spin" title="Connecting"></i>
          </b-col>
        </template>
        <!-- Show disconnected state -->
        <template v-else-if="phoneDisconnected">
          <b-col v-if="!isMinimized">
            <h4 class="mt-0 mb-2">Disconnected</h4><i class="fas fa-exclamation-circle fa-2x" title="Disconnected"></i>
          </b-col>
        </template>
        <!-- Show normal phone stats -->
        <template v-else>
          <b-col v-if="!isMinimized">
            <h4 class="mt-0 mb-2">{{ formattedHold }}</h4><i class="far fa-clock fa-2x" title="Longest Hold"></i>
          </b-col>
          <b-col>
            <h4 class="mt-0 mb-2">{{ callsHolding }}</h4><i class="fas fa-user-friends fa-2x" title="Calls Holding"></i>
          </b-col>
          <b-col v-if="!isMinimized">
            <h4 class="mt-0 mb-2">{{ repsReady }}</h4><i class="fas fa-headset fa-2x" title="Reps Ready"></i>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneStatsDisplay",
  props: {
    phoneConnecting: {
      type: Boolean,
      default: false
    },
    phoneDisconnected: {
      type: Boolean,
      default: true
    },
    isMinimized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Access phone stats directly from $root.$data to avoid prop changes
    callsHolding() {
      return this.$root.$data.dataHubPhoneStats.callsHolding;
    },
    longestHold() {
      return this.$root.$data.dataHubPhoneStats.longestHold;
    },
    repsReady() {
      return this.$root.$data.dataHubPhoneStats.repsReady;
    },
    hasValidStats() {
      return this.longestHold !== null && this.longestHold !== undefined;
    },
    formattedHold() {
      if (!this.hasValidStats) return "0:00";
      return `${Math.floor(this.longestHold / 60)}:${(this.longestHold % 60).toString().padStart(2, "0")}`;
    }
  }
};
</script>
